import { render, staticRenderFns } from "./Saleitems.vue?vue&type=template&id=4b8b031b&scoped=true"
import script from "./Saleitems.vue?vue&type=script&lang=js"
export * from "./Saleitems.vue?vue&type=script&lang=js"
import style0 from "./Saleitems.vue?vue&type=style&index=0&id=4b8b031b&prod&lang=css"
import style1 from "./Saleitems.vue?vue&type=style&index=1&id=4b8b031b&prod&scoped=true&lang=css"
import style2 from "./Saleitems.vue?vue&type=style&index=2&id=4b8b031b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8b031b",
  null
  
)

export default component.exports